export default __webpack_public_path__ + "static/media/powell_cat_nolikes.db5beade.png";